'use strict';

var settingsData = require('../config/grid-settings.json');
var _ = require('lodash');
var GridExampleController = function GridExampleController($scope) {
  $scope.settings = settingsData;
  $scope.colNameAdd = 'NewColumn';
  $scope.colNameRemove = 'NewColumn';
  $scope.newWidth = '500px';
  $scope.newHeight = '1200px';
  $scope.addColumn = function () {
    if (!_.find($scope.settings.columns, {
      title: $scope.colNameAdd
    }) && $scope.colNameAdd) {
      var newSettings = _.cloneDeep($scope.settings);
      newSettings.columns.push({
        field: $scope.colNameAdd,
        title: $scope.colNameAdd,
        fieldType: 'string',
        visible: true
      });
      $scope.settings = newSettings;
    }
  };
  $scope.removeColumn = function () {
    var newSettings = _.cloneDeep($scope.settings);
    newSettings.columns = _.reject($scope.settings.columns, {
      title: $scope.colNameRemove
    });
    $scope.settings = newSettings;
  };
  $scope.setWidth = function () {
    var newSettings = _.cloneDeep($scope.settings);
    newSettings.width = $scope.newWidth;
    $scope.settings = newSettings;
  };
  $scope.setHeight = function () {
    var newSettings = _.cloneDeep($scope.settings);
    newSettings.height = $scope.newHeight;
    $scope.settings = newSettings;
  };
};
GridExampleController.$inject = ['$scope', 'DemandTransparencyDataRetrieverService'];
module.exports = GridExampleController;